export const TBM_DATA_CHANGED_EVENT = 'kop:tbm-data-changed';

/** Called only after a server-confirmed TBM mutation. */
export function notifyTbmDataChanged() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(TBM_DATA_CHANGED_EVENT));
}
